import React from "react";

function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.334"
      height="23.999"
      viewBox="0 0 23.334 23.999"
    >
      <path
        id="Path_18534"
        data-name="Path 18534"
        d="M17.389,22.257V4h-3V22.257L6.343,14.211,4.222,16.332,15.889,28,27.556,16.332l-2.121-2.121Z"
        transform="translate(-4.222 -4)"
      />
    </svg>
  );
}

export default DownArrow;
